const StringUtils={}

export default StringUtils